import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataFeverPercentage.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataFeverPercentage.error;
export const dataFeverPercentageResponse = (state: RootState) =>
  state.dataFeverPercentage.dataFeverPercentageResponse;
